export default {
  hoursAgo: 'h. ago'
};
